import React from 'react';
import { Users, UserCheck, UserX, Clock, AlertCircle } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const chartData = [{
  name: 'Mon',
  present: 45,
  absent: 3,
  late: 2
}, {
  name: 'Tue',
  present: 42,
  absent: 4,
  late: 1
}, {
  name: 'Wed',
  present: 46,
  absent: 2,
  late: 0
}, {
  name: 'Thu',
  present: 44,
  absent: 3,
  late: 3
}, {
  name: 'Fri',
  present: 41,
  absent: 5,
  late: 4
}, {
  name: 'Sat',
  present: 30,
  absent: 2,
  late: 1
}, {
  name: 'Sun',
  present: 28,
  absent: 1,
  late: 0
}];
const alerts = [{
  id: 1,
  type: 'late',
  employee: 'John Doe',
  time: '09:15 AM',
  message: 'Late by 15 mins'
}, {
  id: 2,
  type: 'late',
  employee: 'Sarah Smith',
  time: '09:30 AM',
  message: 'Late by 30 mins'
}, {
  id: 3,
  type: 'missing',
  employee: 'Mike Johnson',
  time: 'Yesterday',
  message: 'Missing checkout'
}];
export function Dashboard() {
  return <div className="p-6 space-y-6 max-w-7xl mx-auto" data-id="element-1228">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1229">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex items-center gap-4" data-id="element-1230">
          <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600" data-id="element-1231">
            <Users size={24} data-id="element-1232" />
          </div>
          <div data-id="element-1233">
            <p className="text-sm font-medium text-gray-500" data-id="element-1234">Total Employees</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1235">48</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex items-center gap-4" data-id="element-1236">
          <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1237">
            <UserCheck size={24} data-id="element-1238" />
          </div>
          <div data-id="element-1239">
            <p className="text-sm font-medium text-gray-500" data-id="element-1240">Present Today</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1241">42</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex items-center gap-4" data-id="element-1242">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-1243">
            <UserX size={24} data-id="element-1244" />
          </div>
          <div data-id="element-1245">
            <p className="text-sm font-medium text-gray-500" data-id="element-1246">Absent</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1247">4</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex items-center gap-4" data-id="element-1248">
          <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600" data-id="element-1249">
            <Clock size={24} data-id="element-1250" />
          </div>
          <div data-id="element-1251">
            <p className="text-sm font-medium text-gray-500" data-id="element-1252">Late</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1253">2</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1254">
        {/* Chart */}
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-1255">
          <h3 className="text-lg font-semibold text-gray-800 mb-6" data-id="element-1256">
            Weekly Attendance Overview
          </h3>
          <div className="h-80 w-full" data-id="element-1257">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1258">
              <AreaChart data={chartData} margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0
            }} data-id="element-1259">
                <defs data-id="element-1260">
                  <linearGradient id="colorPresent" x1="0" y1="0" x2="0" y2="1" data-id="element-1261">
                    <stop offset="5%" stopColor="#22C55E" stopOpacity={0.3} data-id="element-1262" />
                    <stop offset="95%" stopColor="#22C55E" stopOpacity={0} data-id="element-1263" />
                  </linearGradient>
                  <linearGradient id="colorAbsent" x1="0" y1="0" x2="0" y2="1" data-id="element-1264">
                    <stop offset="5%" stopColor="#EF4444" stopOpacity={0.3} data-id="element-1265" />
                    <stop offset="95%" stopColor="#EF4444" stopOpacity={0} data-id="element-1266" />
                  </linearGradient>
                </defs>
                <XAxis dataKey="name" stroke="#9CA3AF" fontSize={12} tickLine={false} axisLine={false} data-id="element-1267" />
                <YAxis stroke="#9CA3AF" fontSize={12} tickLine={false} axisLine={false} data-id="element-1268" />
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1269" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1270" />
                <Area type="monotone" dataKey="present" stroke="#22C55E" strokeWidth={2} fillOpacity={1} fill="url(#colorPresent)" name="Present" data-id="element-1271" />
                <Area type="monotone" dataKey="absent" stroke="#EF4444" strokeWidth={2} fillOpacity={1} fill="url(#colorAbsent)" name="Absent" data-id="element-1272" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Alerts */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-1273">
          <div className="flex items-center gap-2 mb-6" data-id="element-1274">
            <AlertCircle className="text-orange-500" size={20} data-id="element-1275" />
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-1276">
              Action Required
            </h3>
          </div>

          <div className="space-y-4" data-id="element-1277">
            {alerts.map(alert => <div key={alert.id} className="p-4 rounded-lg border border-gray-100 bg-gray-50 flex items-start gap-3" data-id="element-1278">
                <div className={`w-2 h-2 mt-2 rounded-full flex-shrink-0 ${alert.type === 'late' ? 'bg-yellow-500' : 'bg-red-500'}`} data-id="element-1279"></div>
                <div data-id="element-1280">
                  <p className="text-sm font-semibold text-gray-800" data-id="element-1281">
                    {alert.employee}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-1282">{alert.message}</p>
                  <p className="text-xs font-medium text-gray-400 mt-2" data-id="element-1283">
                    {alert.time}
                  </p>
                </div>
              </div>)}
          </div>

          <button className="w-full mt-6 py-2 text-sm font-medium text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 rounded-lg transition-colors" data-id="element-1284">
            View All Alerts
          </button>
        </div>
      </div>
    </div>;
}